import { createWebHistory, createRouter } from 'vue-router'


import authRoutes from './auth';
import userAdminRoutes from './userAdmin';

var routes = [];

routes.push(...authRoutes);

routes.push(...userAdminRoutes);


const router = createRouter({
  history: createWebHistory(),
  routes,
});


export default router;